import { ListResponseModel } from ".";
import { ProductCategory } from "../model/appliance";
import { apiSlice } from "../stores/base/api-slice";

const serviceBaseurl = "/product/category"

const categoryEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getProductCategories: builder.query<ListResponseModel<Array<ProductCategory>>, void>({
			providesTags: ["ProductCategory"],
			query: () => ({
				url: serviceBaseurl,
				method: "GET",
			}),
		}),
		createProductCategory: builder.mutation<any, FormData>({
            invalidatesTags: ["ProductCategory"],
			query: formData => ({
				url:serviceBaseurl,
				method: "POST",
				body: formData,
			}),
		}),
		updateProductCategory: builder.mutation<any, FormData>({
            invalidatesTags: ['ProductCategory'],
			query: formData => ({
				url: serviceBaseurl,
				method: "PUT",
				body: formData,
			}),
		}),
	}),
});

export const { useGetProductCategoriesQuery, useLazyGetProductCategoriesQuery, useCreateProductCategoryMutation, useUpdateProductCategoryMutation } = categoryEndpoints;
